export const getServerURLBase = (override?: 'DEV' | 'TEST' | 'PROD') => {
  const { NODE_ENV, REACT_APP_ENV_OVERRIDE } = process.env;
  const isTest = /mitest\./.test(window.location.href);
  const isLocal = NODE_ENV === 'development' || /localhost/.test(window.location.href);
  // eslint-disable-next-line no-nested-ternary
  const ENV = isLocal ? 'DEV' : isTest ? 'TEST' : 'PROD';
  const urlBase = process.env[`REACT_APP_${override || REACT_APP_ENV_OVERRIDE || ENV}_BACK`] as string;
  return urlBase;
};
